/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Page_Compare_DescInputs */

const en_pc_page_compare_desc = /** @type {(inputs: Pc_Page_Compare_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft ArtCraft vs Adobe Photoshop: price, PSD support, layers, adjustments, AI, platforms and automation, with a hands-on review of the open-source editor.`)
};

const zh_pc_page_compare_desc = /** @type {(inputs: Pc_Page_Compare_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft ArtCraft 与 Adobe Photoshop 全面对比：价格、PSD 支持、图层、调整、AI、平台与自动化，附开源编辑器上手体验。`)
};

/**
* | output |
* | --- |
* | "PhotoCraft ArtCraft vs Adobe Photoshop: price, PSD support, layers, adjustments, AI, platforms and automation, with a hands-on review of the open-source editor." |
*
* @param {Pc_Page_Compare_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_page_compare_desc = /** @type {((inputs?: Pc_Page_Compare_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Page_Compare_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_page_compare_desc(inputs)
	return zh_pc_page_compare_desc(inputs)
});
export { pc_page_compare_desc as "pc.page.compare.desc" }